// extracted by mini-css-extract-plugin
export default {"switcher":"HinhAnhMonAn_switcher__5--e5","search":"HinhAnhMonAn_search__-r4cL"};